import {
  CommunityEventMilestone,
  PlayerCommunityEvent,
} from '../state/communityJackpot.types';

export const getMilestoneRewards = (
  prizes: CommunityEventMilestone['prizes'],
) =>
  prizes.reduce(
    (accumulator, prize) => accumulator + prize.numberOfRewards,
    0,
  ) || 0;

export const getMilestoneFlipReward = (
  activeMilestone?: CommunityEventMilestone,
) =>
  activeMilestone &&
  activeMilestone.prizes.find(
    ({ rewardType }) => rewardType === 'MilestoneFlip',
  );

export const checkAllMilestonesCompleted = (
  playerEvent: PlayerCommunityEvent,
) =>
  playerEvent.milestones.every(
    (milestone) =>
      milestone.status === 'Completed' || milestone.status === 'RewardPending',
  );

export const getActiveMilestone = (playerEvent: PlayerCommunityEvent) =>
  playerEvent.milestones.find(
    ({ status }) => status === undefined || status === null,
  );
